import { Container } from 'ui/container'
import { Stats } from 'features/admin/stats'
import { Link } from 'react-router-dom'
import { routes } from 'core/routes/paths'

import c from '../assets/sass/page.module.scss'

const AdminStatsPage = () => {
    return (
        <div className={c.component}>
            <div className={c.header}>
                <Link to={routes.admin} className={c.back}>
                    ← Назад
                </Link>
                <span className={c.title}>Статистика</span>
            </div>
            <Container>
                <Stats />
            </Container>
        </div>
    )
}

export default AdminStatsPage
